import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import _toConsumableArray from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import { i18n } from "@/i18n/i18n-setup";

var CreateNotification =
/*#__PURE__*/
function () {
  function CreateNotification() {
    _classCallCheck(this, CreateNotification);

    this.sendMorningNoticeList = [];
    this.sendEveningNoticeList = [];
    this.moringTime = 8; //早上八点

    this.eveningTime = 21; //晚上九点

    this.noticeList = 5; //早晚各发五条

    this.testTime = 1000; //本地测试用的

    this.morningNoticeList = [{
      title: i18n.t("notification.morgin_notice_list[0].title"),
      content: i18n.t("notification.morgin_notice_list[0].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.morgin_notice_list[1].title"),
      content: i18n.t("notification.morgin_notice_list[1].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.morgin_notice_list[2].title"),
      content: i18n.t("notification.morgin_notice_list[2].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.morgin_notice_list[3].title"),
      content: i18n.t("notification.morgin_notice_list[3].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.morgin_notice_list[4].title"),
      content: i18n.t("notification.morgin_notice_list[4].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.morgin_notice_list[5].title"),
      content: i18n.t("notification.morgin_notice_list[5].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.morgin_notice_list[6].title"),
      content: i18n.t("notification.morgin_notice_list[6].content"),
      customData: {
        type: "notice-data"
      }
    }];
    this.eveningNoticeList = [{
      title: i18n.t("notification.evenging_notice_list[0].title"),
      content: i18n.t("notification.evenging_notice_list[0].content"),
      customData: {
        type: "notice-data"
      }
    }, // {
    //   title: i18n.t("notification.evenging_notice_list[1].title"),
    //   content: i18n.t("notification.evenging_notice_list[1].content"),
    //   customData: { type: "notice-data", needRepale: true }
    // },
    {
      title: i18n.t("notification.evenging_notice_list[2].title"),
      content: i18n.t("notification.evenging_notice_list[2].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.evenging_notice_list[3].title"),
      content: i18n.t("notification.evenging_notice_list[3].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.evenging_notice_list[4].title"),
      content: i18n.t("notification.evenging_notice_list[4].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.evenging_notice_list[5].title"),
      content: i18n.t("notification.evenging_notice_list[5].content"),
      customData: {
        type: "notice-data"
      }
    }, {
      title: i18n.t("notification.evenging_notice_list[6].title"),
      content: i18n.t("notification.evenging_notice_list[6].content"),
      customData: {
        type: "notice-data"
      }
    }];

    this.checkNotificationStatus = function () {
      return new _Promise(function (resolve, reject) {
        try {
          Cordova.exec(function (result) {
            // console.info("checkNotificationStatus:", result);
            resolve(result);
          }, function (error) {
            // console.info("checkNotificationStatus error:", error);
            reject(error);
          }, "ThirdPartyPlugin", "CheckNotificationStatus", null);
        } catch (error) {
          reject(error);
        }
      });
    };

    this.HandleNotificationStatus = function () {
      return new _Promise(function (resolve, reject) {
        try {
          Cordova.exec(function (result) {
            // console.info("HandleNotificationStatus:", result);
            resolve(result);
          }, function (error) {
            // console.info("HandleNotificationStatus error:", error);
            reject(error);
          }, "ThirdPartyPlugin", "HandleNotificationStatus", null);
        } catch (error) {
          reject(error);
        }
      });
    };

    this.CancelLocalNotification = function () {
      return new _Promise(function (resolve, reject) {
        try {
          Cordova.exec(function (result) {
            // console.info("CancelLocalNotification:", result);
            resolve(result);
          }, function (error) {
            // console.info("CancelLocalNotification error:", error);
            reject(error);
          }, "ThirdPartyPlugin", "CancelLocalNotification", null);
        } catch (error) {
          reject(error);
        }
      });
    };

    this.ShowNotification = function (noticeData) {
      Cordova.exec(function (result) {// console.info("sendEvent:", result);
      }, function (error) {// console.info("sendEvent error:", error);
      }, "ThirdPartyPlugin", "ShowNotification", noticeData);
    };
  }

  _createClass(CreateNotification, [{
    key: "sendNotification",
    value: function () {
      var _sendNotification = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var isNeddCheckNoticeToday, isOpenNotification, noticeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.CancelLocalNotification();

              case 2:
                isNeddCheckNoticeToday = this.isNeddCheckNoticeToday();

                if (!isNeddCheckNoticeToday) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return this.checkNotificationStatus();

              case 6:
                isOpenNotification = _context.sent;

                // console.log('isOpenNotification',isOpenNotification);
                if (isOpenNotification === "false" || isOpenNotification === "closed") {
                  store.commit(types.SHOW_TOAST, {
                    show: true,
                    title: i18n.t("toast.notification_title"),
                    topImg: require("@/assets/toast/stay_informed.png"),
                    content: i18n.t("toast.notificatin_content"),
                    confirm: "<div class=\"flex-center\" style=\"width:100%;height:100%;background:#603BF3;color: #fff;font-family:Assistant-SemiBold;font-size:16px;border-radius:8px;\">".concat(i18n.t("toast.trun_on_notification"), "</div>"),
                    confirmFn: this.HandleNotificationStatus,
                    cancel: "<div class=\"flex-center\" style=\"width:100%;height:100%;color:#CDCBD6;\">".concat(i18n.t("toast.not_now"), "</div>")
                  });
                }

              case 8:
                if (store.getters[types.GETTER_MORNING_NOOTICE_STATUS]) {
                  this.getMorningNotificationList();
                }

                if (store.getters[types.GETTER_EVNING_NOOTICE_STATUS]) {
                  this.getEveningNotificationList();
                }

                noticeList = [].concat(_toConsumableArray(this.sendMorningNoticeList), _toConsumableArray(this.sendEveningNoticeList)); // console.log(this.sendMorningNoticeList, this.sendEveningNoticeList);

                if (noticeList.length > 0) {
                  this.ShowNotification(noticeList);
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendNotification() {
        return _sendNotification.apply(this, arguments);
      }

      return sendNotification;
    }()
  }, {
    key: "isNeddCheckNoticeToday",
    value: function isNeddCheckNoticeToday() {
      var checkNoticeDayTime = localStorage.getItem("check_notice_day_time");
      var dayTime = new Date().getDate();

      if (!checkNoticeDayTime || checkNoticeDayTime && JSON.parse(checkNoticeDayTime) !== dayTime) {
        localStorage.setItem("check_notice_day_time", _JSON$stringify(dayTime));
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "getMorningNotificationList",
    value: function getMorningNotificationList() {
      var nowTime = new Date().valueOf();
      var todayStr = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
      var todayZeroTime = new Date(todayStr).getTime(); // 当天0点时间戳

      var toadyMoringTime = todayZeroTime + this.moringTime * 60 * 60 * 1000;
      var startTime = 0;

      if (nowTime < toadyMoringTime) {
        startTime = toadyMoringTime - nowTime; //第一条通知早当天八点发;
      } else {
        startTime = todayZeroTime + (this.moringTime + 24) * 60 * 60 * 1000 - nowTime; //第一条通知第二天早上发,第二天早八点时间，减去现在的时间
      }

      for (var j = 0; j < this.noticeList; j++) {
        var randNumber = this.randomNoitceNum(this.morningNoticeList);
        var noticeData = this.morningNoticeList.splice(randNumber, 1)[0];
        var pushData = {
          title: noticeData.title,
          content: noticeData.content,
          customData: noticeData.customData,
          timeInterval: startTime + j * 24 * 60 * 60 * 1000 // timeInterval: this.testTime + j * 1000

        };
        this.sendMorningNoticeList.push(pushData);
      }
    }
  }, {
    key: "getEveningNotificationList",
    value: function getEveningNotificationList() {
      var nowTime = new Date().valueOf();
      var todayStr = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
      var todayZeroTime = new Date(todayStr).getTime(); // 当天0点时间戳

      var toadyEveningTime = todayZeroTime + this.eveningTime * 60 * 60 * 1000;
      var startTime = 0;

      if (nowTime < toadyEveningTime) {
        startTime = toadyEveningTime - nowTime; //第一条通知早当天八点发;
      } else {
        startTime = todayZeroTime + (this.eveningTime + 24) * 60 * 60 * 1000 - nowTime; //第一条通知第二天晚上发，第二天晚上九点，减去现在的时间
      }

      for (var j = 0; j < this.noticeList; j++) {
        var randNumber = this.randomNoitceNum(this.eveningNoticeList);
        var noticeData = this.eveningNoticeList.splice(randNumber, 1)[0];
        var horoscope = store.getters[types.GETTER_HOROSCOPE];
        var pushTitle = noticeData.customData.needRepale ? horoscope ? "\uD83D\uDC98Pisces ".concat(horoscope, " Daily Horoscope") : "💘Daily Horoscope" : noticeData.title;
        var pushData = {
          title: pushTitle,
          content: noticeData.content,
          customData: noticeData.customData,
          timeInterval: startTime + j * 24 * 60 * 60 * 1000 // timeInterval: this.testTime + (j + 1) * 1000

        };
        this.sendEveningNoticeList.push(pushData);
      }
    }
  }, {
    key: "randomNoitceNum",
    value: function randomNoitceNum(noticeArr) {
      // console.log('noticeArr',noticeArr)
      return Math.floor(Math.random() * noticeArr.length);
    }
  }]);

  return CreateNotification;
}();

export { CreateNotification as default };